import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register(
  'cf-device-detection-log',
  class extends Controller {
    connect () {
      this.sendRequest()
    }

    sendRequest () {
      const requestBody = {
        client_screen_width: window.innerWidth,
        url: window.location.href,
        client_user_agent: navigator.userAgent || 'Unknown'
      }

      fetch('/api/cf_device_detection_logs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      })
    }
  }
)
